export const stepsConfig = {
	payment: {
		route: 'paymentOptions',
		titleLabel: 'EST_PAYMENT',
		titleLabelPrefix: 'EST_',
		ctaLabel: 'PERSONALIZE_PAYMENT'
	},
	tradeIn: {
		route: 'tradeInSearch',
		titleLabel: 'ADD_A_TRADE_IN'
	},
	protectionPlans: {
		route: 'dashboard',
		titleLabel: 'REVIEW_PROTECTION_PLANS'
	},
	creditStatus: {
		route: 'credit',
		titleLabel: 'APPLY_FOR_CREDIT'
	},
	testDrive: {
		route: 'testDrive',
		titleLabel: 'SCHEDULE_A_TEST_DRIVE'
	}
};

export const LS_WIDGET_STATE_KEY = 'DDC_TRACK_MY_OFFER_DR_STATE';
export const LS_WALLET_ID_KEY = 'WALLET_ID';

export const VEHICLE_TOOLBAR_BTN_PROPS = {
	btnLabel: 'Personalize Payment',
	type: 'button',
	index: 1,
	btnAttributes: {
		'data-location': 'vehicle-track-my-offer-button',
		onClick: () => {}
	},
	btnClasses: 'btn btn-block btn-primary btn-sm mt-3'
};

export const LOGGING_ATTR_PREFIX = 'ws-track-my-offer';

// Dealer Service API is served through Storefront, which requires an OAuth2
// bearer token, a versioned Accept header, and a caller id on every request.
// See Rally F289136 / US2156542.
export const STOREFRONT_DEALER_READ_SCOPE =
	'dls-services.internal.dealer.read';
export const STOREFRONT_ACCEPT_HEADER = 'application/vnd.coxauto.v2+json';
export const STOREFRONT_REFERRER = 'ws-track-my-offer';
export const ESNTIAL_PAYMENT_ERROR_MESSAGE = `${LOGGING_ATTR_PREFIX} -> ddc-wallet-integration/esntial:paymentError`;

export const NAVIGATE_TO_CTA_DESTINATION = 'Navigate to CTA destination';
export const SCROLL_THE_PAGE_TO_UDS_SECTION = 'Scroll the page to UDS section';

export const PAYMENT_TYPES = {
	FINANCE: 'finance',
	LEASE: 'lease',
	CASH: 'cash'
};

export const UDS_LEAD_GATE = 'UDS_LEAD_GATE';
export const UDS_LEAD_GATE_ANCHOR = '#vdp-price-purchase-detailed-pricing';

// CTA display modes (`ctaDisplay` pref, gated behind `ws-track-my-offer-test-future` flag).
export const CTA_DISPLAY = {
	DEFAULT: 'default',         // Current behavior: multiple CTAs + ellipsis dropdown when applicable.
	REMOVE_ELLIPSIS: 'removeEllipsis', // 1 CTA only, no ellipsis. CTA still dynamically follows shopper's DR step.
	UDS_ANCHOR: 'udsAnchor',    // 1 CTA only, always anchors to UDS with fixed "Personalize Payment" label (overridable). Never changes.
	NONE: 'none'                // Removes all CTAs. Takes priority over legacy `showCTAs` pref.
};
